export const normalizeText = (text: string) =>
  text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

type ObjectWithId = {
  id: number;
  [key: string]: any;
};

type MappedObject<T> = {
  [K in keyof T as K extends string
    ? T[K] extends ObjectWithId
      ? `${K}_id`
      : K
    : never]: T[K] extends ObjectWithId ? number : T[K];
};

export function mapObjectToIds<T extends Record<string, any>>(
  obj: T
): MappedObject<T> {
  let mappedObj = {} as MappedObject<T>;
  for (let key in obj) {
    if (Array.isArray(obj[key])) {
      // Si es un array, mapea cada elemento si tiene un id
      (mappedObj as any)[key] = obj[key].map((item: any) =>
        item && typeof item === "object" && "id" in item ? item.id : item
      );
    } else if (obj[key] && typeof obj[key] === "object" && "id" in obj[key]) {
      // Si es un objeto con un id, mapea el id
      (mappedObj as any)[`${key}`] = (obj[key] as ObjectWithId).id;
    } else {
      // Si no es un objeto con un id, copia el valor directamente
      (mappedObj as any)[key] = obj[key];
    }
  }
  return mappedObj;
}
